import '../button/index.scss';

type ButtonProps = {
    children: any;
    onClick: (arg) => void;
    className: string;
    id?: string;
    type?: string;
    isDisabled?: boolean;
    dataLabel?: string
    style?: any;
}

const Button = ({
    children,
    onClick,
    className, style, id, isDisabled, dataLabel }: ButtonProps) => <button id={id} className={`btn ${className}`} style={style} onClick={onClick} disabled={isDisabled} data-label={dataLabel}>
        {children} </button>

export default Button;